import { Injectable } from "@nestjs/common";
import { EntityRepository, Repository } from "typeorm";
import { ConsolidatedAttendanceLogEntity } from "../entities/consoladate-attendance-logs.entity";
import moment from "moment";
import appSettings from "apps/services/config";
import { EmployeeWorkingHrsRequest } from "@gtpl/shared-models/hrms";
@Injectable()
@EntityRepository(ConsolidatedAttendanceLogEntity)
export class ConsolidatedAttendanceLogRepository extends Repository<ConsolidatedAttendanceLogEntity> {
    constructor() {
        super();
    }

    async getEmployeeCurrentDayRecord(employeeCode: string, logDate: Date) {
        return await this.createQueryBuilder('consolidated_attendance_log')
            .where(`log.employeeCode=${employeeCode}`)
            .andWhere(`log.logDate = ${moment(logDate).format('YYYY-MM-DD')}`)
            .orWhere(`log.logDate = ${moment(logDate).subtract(1, 'day').format('YYYY-MM-DD')} and shift in ('C','D')`)
            .getMany()
    }


    async getEmployeeWorkingHrs(empWorkingHrsReq?: EmployeeWorkingHrsRequest): Promise<any> {
        let query = `
        SELECT 
            cal.employee_name AS employeeName,
            cal.employee_code AS employeeCode,
            cal.log_date AS logDate,
            ed.department_id,
            ed.employee_type,
            ed.emp_category,
            d.dept_name AS deptName,
            DATE_FORMAT(cal.in_time_1, '%H:%i') AS inTime1,
            DATE_FORMAT(cal.out_time_1, '%H:%i') AS outTime1,
            CASE
                WHEN cal.in_time_1 IS NULL OR cal.out_time_1 IS NULL THEN NULL
                WHEN cal.out_time_1 = '00:00' OR cal.out_time_1 < cal.in_time_1 THEN NULL
                ELSE DATE_FORMAT(TIMEDIFF(cal.out_time_1, cal.in_time_1), '%H:%i')
            END AS duration1,
            DATE_FORMAT(cal.in_time_2, '%H:%i') AS inTime2,
            DATE_FORMAT(cal.out_time_2, '%H:%i') AS outTime2,
            CASE
                WHEN cal.in_time_2 IS NULL OR cal.out_time_2 IS NULL THEN NULL
                WHEN cal.out_time_2 = '00:00' OR cal.out_time_2 < cal.in_time_2 THEN NULL
                ELSE DATE_FORMAT(TIMEDIFF(cal.out_time_2, cal.in_time_2), '%H:%i')
            END AS duration2,
            DATE_FORMAT(cal.in_time_3, '%H:%i') AS inTime3,
            DATE_FORMAT(cal.out_time_3, '%H:%i') AS outTime3,
            CASE
                WHEN cal.in_time_3 IS NULL OR cal.out_time_3 IS NULL THEN NULL
                WHEN cal.out_time_3 = '00:00' OR cal.out_time_3 < cal.in_time_3 THEN NULL
                ELSE DATE_FORMAT(TIMEDIFF(cal.out_time_3, cal.in_time_3), '%H:%i')
            END AS duration3,
            DATE_FORMAT(cal.in_time_4, '%H:%i') AS inTime4,
            DATE_FORMAT(cal.out_time_4, '%H:%i') AS outTime4,
            CASE
                WHEN cal.in_time_4 IS NULL OR cal.out_time_4 IS NULL THEN NULL
                WHEN cal.out_time_4 = '00:00' OR cal.out_time_4 < cal.in_time_4 THEN NULL
                ELSE DATE_FORMAT(TIMEDIFF(cal.out_time_4, cal.in_time_4), '%H:%i')
            END AS duration4,
            DATE_FORMAT(cal.in_time_5, '%H:%i') AS inTime5,
            DATE_FORMAT(cal.out_time_5, '%H:%i') AS outTime5,
            CASE
                WHEN cal.in_time_5 IS NULL OR cal.out_time_5 IS NULL THEN NULL
                WHEN cal.out_time_5 = '00:00' OR cal.out_time_5 < cal.in_time_5 THEN NULL
                ELSE DATE_FORMAT(TIMEDIFF(cal.out_time_5, cal.in_time_5), '%H:%i')
            END AS duration5,
            DATE_FORMAT(cal.in_time_6, '%H:%i') AS inTime6,
            DATE_FORMAT(cal.out_time_6, '%H:%i') AS outTime6,
            CASE
                WHEN cal.in_time_6 IS NULL OR cal.out_time_6 IS NULL THEN NULL
                WHEN cal.out_time_6 = '00:00' OR cal.out_time_6 < cal.in_time_6 THEN NULL
                ELSE DATE_FORMAT(TIMEDIFF(cal.out_time_6, cal.in_time_6), '%H:%i')
            END AS duration6, 
            DATE_FORMAT(
                SEC_TO_TIME(
                    COALESCE(TIME_TO_SEC(TIMEDIFF(cal.out_time_1, cal.in_time_1)), 0) +
                    COALESCE(TIME_TO_SEC(TIMEDIFF(cal.out_time_2, cal.in_time_2)), 0) +
                    COALESCE(TIME_TO_SEC(TIMEDIFF(cal.out_time_3, cal.in_time_3)), 0) +
                    COALESCE(TIME_TO_SEC(TIMEDIFF(cal.out_time_4, cal.in_time_4)), 0) +
                    COALESCE(TIME_TO_SEC(TIMEDIFF(cal.out_time_5, cal.in_time_5)), 0) +
                    COALESCE(TIME_TO_SEC(TIMEDIFF(cal.out_time_6, cal.in_time_6)), 0)
                ),
                '%H:%i'
            ) AS totalHours
        FROM erpx_dev_hrms.consolidated_attendance_log cal
        LEFT JOIN ${appSettings.masters_db}.employee_details ed ON cal.employee_code = ed.employee_code
          LEFT JOIN ${appSettings.masters_db}.departments d ON ed.department_id = d.dept_id
        `;

        const filters: string[] = ['ed.employee_type = ?'];
        const params: any[] = [empWorkingHrsReq.empType];

        if (empWorkingHrsReq?.departmentId) {
            filters.push('ed.department_id = ?');
            params.push(empWorkingHrsReq.departmentId);
        }
        if (empWorkingHrsReq?.employeeCode) {
            filters.push('cal.employee_code = ?');
            params.push(empWorkingHrsReq.employeeCode);
        }
        if (empWorkingHrsReq?.logDateStartDate && empWorkingHrsReq?.logDateEndDate) {
            filters.push('cal.log_date BETWEEN STR_TO_DATE(?, "%Y-%m-%d") AND STR_TO_DATE(?, "%Y-%m-%d")');
            params.push(empWorkingHrsReq.logDateStartDate, empWorkingHrsReq.logDateEndDate);
        }
        if (empWorkingHrsReq?.category) {
            filters.push('ed.emp_category = ?');
            params.push(empWorkingHrsReq.category);
        }

        if (filters.length > 0) {
            query += ' WHERE ' + filters.join(' AND ');
        }

        const result = await this.query(query, params);
        return result;
    }
















}